export const FAILURE_STATUSES = ["not_authorized", "not_found", "structural_error", "error"] as const;

export const TABLE_STATUS_LABEL: Record<string, string> = {
  data: "With data",
  empty: "Empty",
  not_authorized: "Not authorized",
  not_found: "Not found",
  structural_error: "Structural error",
  error: "Error",
};
